import Linkify from "../../shared/linkify";
import PropTypes from "prop-types";
import React from "react";

const PhotoWrapper = ({ entity, customClasses }) => {
  const classes = [
    customClasses || "",
    entity.photo && !entity.photo.isLandscape ? "portrait-img" : "",
    entity.videoUrl ? "has-bio-video" : "",
    "col-sm-8 col-xs-16",
  ];

  return (
    entity.hasPhoto && (
      <div className={classes.join(" ")}>
        <Linkify to={"/about"}>
          <img
            src={entity.photo.url}
            alt={`visit ${entity.displayName}'s about page`}
          />
        </Linkify>
      </div>
    )
  );
};

PhotoWrapper.propTypes = {
  customClasses: PropTypes.string,
  entity: PropTypes.object.isRequired,
};

export default PhotoWrapper;



// WEBPACK FOOTER //
// ./src/components/homepage/agent/photo-wrapper.js